import { Grid } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { queryParams } from 'utils/query';
import { useSearchParameters } from 'hooks/useSearchParameters';
import { ReportsStatus } from 'utils/models';
import { TableConfig } from 'models/general';
import { SelectWithSearch } from 'components/ControlledInputs/SelectWithSearch';
import { FilterStatus } from 'components/Table/Filters/FilterStatus';
import { FilterGroups } from 'components/Table/Filters/FilterGroups';
import { InfoIcon } from 'components/InfoIcon';
import { PortalButton } from 'components/Button/PortalButton';
import { useState } from 'react';

interface Props {
  config: TableConfig;
  searchByName?: boolean;
}

export const ReportsListFilters = ({ config, searchByName = true }: Props) => {
  const { queryKey } = config;
  const { t } = useTranslation();
  const { parameters: filters, setParameters, resetParameters } = useSearchParameters(queryKey);
  const [searchValue, setSearchValue] = useState('');

  const handleFilterChange = (filterKey: string, input: string) => {
    setParameters({ ...filters, [filterKey]: input });
  };

  const statusChoices = Object.values(ReportsStatus).map((status: ReportsStatus) => ({
    value: status,
    label: t(`label_reports_status_${status.toLowerCase()}`),
  }));

  const handleResetAction = () => {
    resetParameters();
    setSearchValue('');
  };

  return (
    <Grid p={'xs'} align={'center'}>
      {searchByName && (
        <Grid.Col span={2}>
          <SelectWithSearch
            onChange={(value) => handleFilterChange(queryParams.id, value)}
            value={filters[queryParams.id]}
            placeholder={t('search_by_name_label')}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            testId={queryKey}
          />
        </Grid.Col>
      )}
      <Grid.Col span={2}>
        <FilterGroups queryKey={queryKey} />
      </Grid.Col>
      <Grid.Col span={2}>
        <FilterStatus config={config} choices={statusChoices} />
      </Grid.Col>
      <Grid.Col span={searchByName ? 5.75 : 7.75} ta={'right'}>
        <PortalButton
          onClick={handleResetAction}
          label={t('reset_filters')}
          variant={'outline'}
          testId={'reset-filters'}
        />
      </Grid.Col>
      <Grid.Col span={0.25} ta={'right'}>
        <InfoIcon i18nKey={searchByName ? 'reports_tooltip' : 'patientdetails_reports_tooltip'} />
      </Grid.Col>
    </Grid>
  );
};
